<template>
  <div class="page_judge_freeMatches">
    <h1>{{ 'freeMatches' | cz }}</h1>
    <tabloid name="freeMatches" :columns="columns" :data="matches" defaultOrderBy="order">
      <template v-slot:teamA="{ row }">
        {{ row | bracket_team_name_a }}
      </template>
      <template v-slot:teamB="{ row }">
        {{ row | bracket_team_name_b }}
      </template>
      <template v-slot:bracket="{ value }">
        {{ value | emptyOrName }}
      </template>
      <template v-slot:category="{ value }">
        {{ value | cz }}
      </template>
      <template v-slot:field="{ value }">
        {{ value | emptyOrName }}
      </template>
      <template v-slot:actions="{ row }">
        <button @click="take(row)" class="take" title="Převzít zápas"> 
          <i class="fa fa-gavel"></i>
        </button>
      </template>
    </tabloid>
  </div>
</template>
  
<script>
import { _ } from "../../extend";
import tabloid from "../../components/tabloid.vue";

export default {
  name: "judge_freeMatches",
  components: {
    tabloid,
  },
  data: () => ({
    columns: {
      order: { title: "#" },
      teamA: { title: "1. tým", orderBy: value => value.id },
      teamB: { title: "2. tým", orderBy: value => value.id },
      bracket: { title: "Skupina", orderBy: value => value.name },
      category: { title: "Kategorie" },
      field: { title: "Hřiště", orderBy: value => value != null ? value.name : null },
      actions: { title: "" },
    },
  }),
  computed: {
    matches() {
      var filteredMatches = _.filter(this.$store.getters.matchesWithRelatedData, m => m.judge == null && m.teamA != null && m.teamB != null);
      return filteredMatches;
    },
  },
  methods: {
    take(match) {
      var myId = this.$store.state.login.id;
      this.$store.commit("update", {
        paths: [ 'matches', match.id, 'judgeId' ],
        value: myId,
      });
      this.$store.dispatch('save');
      this.$store.commit("update", {
        paths: [ 'matches', match.id, 'canSetScore' ],
        value: true,
      });
    }
  }
};
</script>
  
<style lang="sass">
  @import ../../sass/_components
  
  .page_judge_freeMatches
    @include table-view()
    grid-template-areas: "label actions" "table table"
    grid-template-columns: auto 1fr
    grid-column-gap: 1rem
  
    h1
      grid-area: label
    .actions
      grid-area: actions
    table
      grid-area: table
      .take
        @include button-primary()
  </style>